import { Invoice } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseInvoiceAction, deleteCaseInvoiceAction, deleteCaseInvoicesAction, setCaseInvoicesAction } from '../reducers/caseInvoiceReducer';

export const useCaseInvoiceActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceCaseInvoice = (invoice: Invoice) => {
        dispatch(addOrReplaceCaseInvoiceAction(invoice));
    }

    const setCaseInvoices = (invoices: Invoice[]) => {
        dispatch(setCaseInvoicesAction(invoices));
    }

    const removeCaseInvoice = (invoiceId: string) => {
        dispatch(deleteCaseInvoiceAction(invoiceId));
    }

    const removeCaseInvoices = (invoiceIds: string[]) => {
        dispatch(deleteCaseInvoicesAction(invoiceIds));
    }

    return { addOrReplaceCaseInvoice, setCaseInvoices, removeCaseInvoice, removeCaseInvoices };
}
